/**
 * Display labels for container efficiency segment states.
 * Single source of truth so labels can be updated globally in one place.
 */
export type SegmentState =
  | "scale_down"
  | "scale_up"
  | "rightsized"
  | "autoscaled";

export const SEGMENT_DISPLAY_LABELS: Record<SegmentState, string> = {
  scale_down: "Over-provisioned",
  scale_up: "Under-provisioned",
  rightsized: "Rightsized",
  autoscaled: "Autoscaled",
};

/** Combined label for app variant when rightsized + autoscaled are shown as one segment. */
export const RIGHTSIZED_AUTOSCALED_LABEL = "Rightsized & Autoscaled";
